import { render, staticRenderFns } from "./Pretest.vue?vue&type=template&id=09bd00d8&scoped=true"
import script from "./Pretest.vue?vue&type=script&lang=js"
export * from "./Pretest.vue?vue&type=script&lang=js"
import style0 from "./Pretest.vue?vue&type=style&index=0&id=09bd00d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd00d8",
  null
  
)

export default component.exports